import InvoiceResource from "./invoice.resource";

const invoiceModule = angular
  .module("app.resources.invoice", [])
  .service("Invoice", InvoiceResource);

export default invoiceModule;



// WEBPACK FOOTER //
// ./src/resources/invoice/invoice.module.js